
import React, { useEffect, useState } from "react";
import {
  IonPage,
  IonContent,
  IonHeader,
  IonToast,
  useIonViewWillEnter,
} from "@ionic/react";
import { useHistory, useLocation } from "react-router-dom";
import axios from "axios";
import { baseUrl, config, requestID } from "../../common/utils";
import { Edit, Delete, LocationOn, Phone, Email, MonetizationOn } from "@mui/icons-material";
import {
  Box,
  Button,
  IconButton,
  Typography,
  Card,
  CardContent,
  CardHeader,
  Skeleton,
} from "@mui/material";
import {motion} from "framer-motion";
import { useBusinessContext } from "../../context/business-context";
import EditBranchModal from "./EditBranch";
import { formatCurrencyN } from "../../common/utils_t";


const Branches: React.FC = () => {
  const [showToast, setShowToast] = useState(false);
  const [message, setMessage] = useState("");
  const [branches, setBranches] = useState<any[]>([]);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const location = useLocation();

    const { selectedBusinessId, selectedBusinessName } = useBusinessContext();

  useEffect(() => {
    fetchBranches();
    
  }, []);

  const fetchBranches = async () => {
    
    try {
      const response = await axios.post(
        baseUrl() + "Businesss/getBranchList2",
        { requestID: requestID(), business_id: selectedBusinessId },
        config
      );
      console.log(response)
      console.log("responseb", response.data.data );
      setBranches(response.data.data || []);
      console.log("Branches:", branches);
    } catch (error) {
      console.error("Error fetching branches:", error);
    } finally {
      setLoading(false);
    }
  };

  const deleteBranch = async (branchId: string) => {
    try {
      await axios.post(
        baseUrl() + "business/deleteBranch",
        { requestID: requestID(), branch_id: branchId },
        config
      );
      setBranches(branches.filter((branch) => branch.branch_id !== branchId));
    } catch (error) {
      console.error("Error deleting branch:", error);
    }
  };

  const handleUpdateBranch = (branch: any) => {
    setSelectedBranch(branch);
    setOpenEditModal(true);
  }

  useIonViewWillEnter(() => {
    fetchBranches();
  });
  return (
    <IonPage className="pushDown">
      <IonHeader style={{ backgroundColor: "white" }}>
        <Box display="flex" justifyContent="space-between" p={2}>
          <Typography variant="h6" sx={{ color: "chocolate" }}>
            {selectedBusinessName?.toUpperCase()} - BRANCHES
          </Typography>
          <Box>

          


            <Button
              variant="contained"
              color="primary"
              onClick={() => history.push(`/folder/createbranches/${selectedBusinessId}`)}
            >
              Create Branch
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => history.goBack()}
              style={{ marginLeft: 10 }}
            >
              Go Back
            </Button>
          </Box>
        </Box>
      </IonHeader>
      <IonContent className="ion-padding">
        {loading
          ? Array.from({ length: 3 }).map((_, index) => (
              <Card key={index} sx={{ marginBottom: 2 }}>
                <CardHeader
                  title={<Skeleton width="50%" />}
                />
                <CardContent>
                  <Skeleton width="80%" />
                  <Skeleton width="60%" />
                  <Skeleton width="40%" />
                  <Box display="flex" justifyContent="flex-end" mt={2}>
                    <Skeleton variant="circular" width={40} height={40} sx={{ marginRight: 1 }} />
                    <Skeleton variant="circular" width={40} height={40} />
                  </Box>
                </CardContent>
              </Card>
            ))
          : branches.map((branch,i) => (
              <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      viewport={{ once: true }}
    >
      <Card
        key={i}
        sx={{
          borderRadius: 3,
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
          transition: "transform 0.3s ease-in-out",
          "&:hover": {
            transform: "scale(1.02)",
            boxShadow: "0px 6px 18px rgba(0, 0, 0, 0.15)",
          },
          backgroundColor: "#fff",
            padding: 2,
            marginBottom: 2,
        }}
      >
        <CardHeader
          title={
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{ color: "darkgreen", textTransform: "uppercase" }}
            >
              {branch.name}
            </Typography>
          }
          sx={{ borderBottom: "1px solid #eee" }}
        />
        <CardContent>
          <Box display="flex" alignItems="center" gap={1} mb={1}>
            <LocationOn sx={{ color: "#ff9800" }} />
            <Typography variant="body2" color="text.secondary">
              {branch.address}
            </Typography>
          </Box>
          <Box display="flex" alignItems="center" gap={1} mb={1}>
            <Phone sx={{ color: "#4caf50" }} />
            <Typography variant="body2" color="text.secondary">
              {branch.phone}
            </Typography>
          </Box>
          <Box display="flex" alignItems="center" gap={1} mb={2}>
            <Email sx={{ color: "#2196f3" }} />
            <Typography variant="body2" color="text.secondary">
              {branch.email}
            </Typography>
          </Box>
          <Box display="flex" alignItems="center" gap={1} mb={2}>
  <MonetizationOn sx={{ color: "#2196f3" }} />
  <Typography variant="body2" className="branchBalanceAmount"  >
    Wallet Balance: {formatCurrencyN(branch.walletBalance)}
  </Typography>
</Box>
          <Box display="flex" justifyContent="flex-end">
            <IconButton
              color="primary"
                      onClick={() => handleUpdateBranch(branch)}
            >
              <Edit />
            </IconButton>
            <IconButton color="error" onClick={() => deleteBranch(branch.branch_id)}>
              <Delete />
            </IconButton>
          </Box>
        </CardContent>
      </Card>
    </motion.div>
            ))}
      </IonContent>


      <EditBranchModal
        open={openEditModal}
        onClose={() => setOpenEditModal(false)}
        branch={selectedBranch}
        onBranchUpdated={fetchBranches}
        setMessage={setMessage}
        setShowToast={setShowToast}

      />
      <IonToast
        isOpen={message !== ""}
        onDidDismiss={() => setShowToast(false)}
        message={message}
        duration={2000}
        position="bottom"
        color={message === "Branch Updated Successfully" ? "success" : "danger"}
        />
    </IonPage>
  );
};

export default Branches;
